import React from 'react';
import { connect } from 'react-redux';

import add from '../../../REST/add';
import { addBookingEntry } from '../../actions/booking-entry-actions';
import { getLastMonthRange } from '../../utils';
import BookingEntryForm from '../BookingEntryForm';
import { transformForPatch } from '../transform-booking-entry-helpers';

const [serviceStartDate, serviceEndDate] = getLastMonthRange(new Date());

export default connect(null, { onAdd: addBookingEntry })(
  add({
    default: {
      debitAmount: 0,
      discount: 0,
      created: '',
      lastModified: '',
      createdBy: '',
      lastModifiedBy: '',
      serviceStartDate,
      serviceEndDate,
    },
    update: ({ opportunityId, onAdd, onSuccess }, changedModel) =>
      onAdd(transformForPatch({ ...changedModel, opportunityId })).then(
        onSuccess,
      ),
    form: props => <BookingEntryForm newModel {...props} />,
  }),
);
